<div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="h1 pr-16">Factura</div>
</div>
<mat-list *ngIf="factura">
    <mat-list-item>
        <h3 matLine>
            Nro. Factura ({{ factura.pagada ? "Pagada" : "Impaga" }})
        </h3>
        <p matLine>
            <span class="secondary-text">{{ factura.numero }} </span>
        </p>
    </mat-list-item>

    <mat-list-item>
        <h3 matLine>Cliente</h3>
        <p matLine>
            <span class="text-bold">{{ factura.cliente.nombre }}</span>
            <span class="secondary-text"> - {{ factura.rutFacturado }}</span>
        </p>
    </mat-list-item>
    <mat-list-item>
        <h3 matLine>Fecha de facturación</h3>
        <p matLine>
            <span class="secondary-text">{{ factura.fecha }}</span>
        </p>
    </mat-list-item>
    <mat-list-item>
        <h3 matLine>Total bruto</h3>
        <p matLine>
            <span class="text-bold">${{ factura.montoBrutoCLP }}</span>
        </p>
    </mat-list-item>
    <mat-list-item>
        <h3 matLine>IVA</h3>
        <p matLine>
            <span class="text-bold">${{ factura.montoIVA }}</span>
        </p>
    </mat-list-item>
    <mat-list-item>
        <h3 matLine>Total</h3>
        <p matLine>
            <span class="text-bold"
                >${{ factura.montoBrutoCLP + factura.montoIVA }}</span
            >
        </p>
    </mat-list-item>
</mat-list>

<div
    *ngIf="factura && _menuUsuarioSrvc.esSupervisor()"
    class="p-8 pt-16"
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutAlign="start center"
>
    <div>
        <mat-slide-toggle
            [checked]="true"
            (change)="toggleEstadoFactura(factura)"
        >
            {{ factura.pagada ? "MARCAR COMO IMPAGA" : "MARCAR COMO PAGADA" }}
        </mat-slide-toggle>
    </div>
</div>
